// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"639":"3ec4f7d8","865":"8e46374d"}[chunkId] + ".chunk.js");